<template>
	<div class="container">
		<el-card>
			<div slot="header">数据报表</div>
			<div style="height: 100%">
				<el-tabs v-model="activeName" type="border-card">
					<el-tab-pane label="电表历史数据" name="electric">
						<div style="height: 100%">
							<el-form ref="form" :model="form" label-width="80px" size="small" style="margin-top: 15px">
								<el-form-item label="数据时间">
									<el-date-picker v-model="queryParams.createStartTime" type="datetime"
										placeholder="选择开始日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
									<label> 到 </label>
									<el-date-picker v-model="queryParams.createEndTime" type="datetime"
										placeholder="选择结束日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="电表制式">
									<el-select v-model="queryParams.type" placeholder="请选择" clearable filterable
										class="searchTag">
										<el-option v-for="item in meterTypeOptions" :key="item.key" :label="item.value"
											:value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="电表厂商">
									<el-select v-model="queryParams.producer" placeholder="请选择" clearable filterable
										@change="changeProducer" class="searchTag">
										<el-option v-for="item in meterProducerOptions" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="电表编号">
									<el-input v-model="queryParams.meterAddr" clearable class="searchTag"
										@keyup.enter.native="handleQueryElectric(true)"></el-input>
									<!-- <el-select v-model="queryParams.meterAddr" placeholder="请选择" clearable filterable class="searchTag">
										<el-option v-for="item in meterAddrOptions" :key="item.key" :label="item.value"
											:value="item.key"></el-option>
									</el-select> -->
								</el-form-item>
								<el-form-item :label="$root.lesseeCodeLabel" v-if="$root.deviceNameShowFlag">
									<el-input v-model="queryParams.code" clearable class="searchTag"
										@keyup.enter.native="handleQueryElectric(true)"></el-input>
								</el-form-item>
								<el-form-item :label="$root.lesseeNameLabel" v-if="$root.deviceNameShowFlag">
									<el-select v-model="queryParams.name" placeholder="" clearable filterable
										class="searchTag">
										<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
											:value="item.name">
										</el-option>
									</el-select>
								</el-form-item>
								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleQueryElectric(true)">查询</el-button>
								<el-button type="primary" icon="iconfont icon-excel" size="small"
									style="background-color: #23c6c8 !important" @click="exportToExcelElectric">导出
								</el-button>
							</el-form>
							<div class="tableStyle">
								<el-table :data="electricTableData" style="width: fit-content" height="92%"
									id="electricDataReportTable">
									<el-table-column type="index" width="65" label="序号" align="center"
										:index="indexMethodElectric">
									</el-table-column>
									<el-table-column prop="meterAddr" label="电表编号" width="130" align="center">
									</el-table-column>
									<el-table-column prop="code" :label="$root.lesseeCodeLabel" width="100"
										align="center" v-if="$root.deviceNameShowFlag">
									</el-table-column>
									<el-table-column prop="name" :label="$root.lesseeNameLabel" width="150"
										align="center" v-if="$root.deviceNameShowFlag">
									</el-table-column>
									<el-table-column prop="producer" label="电表厂商" width="100" align="center">
									</el-table-column>
									<el-table-column prop="type" label="电表制式" width="110" align="center">
									</el-table-column>
									<el-table-column prop="ctRatio" label="CT变比" width="100" align="center">
									</el-table-column>
									<el-table-column prop="dataTime" label="数据时间" width="160" align="center">
									</el-table-column>
									<el-table-column prop="phaseVoltageA" label="电压A(V)" width="100" align="center">
									</el-table-column>
									<el-table-column prop="phaseVoltageB" label="电压B(V)" width="100" align="center">
									</el-table-column>
									<el-table-column prop="phaseVoltageC" label="电压C(V)" width="100" align="center">
									</el-table-column>
									<el-table-column prop="currentA" label="电流A(A)" width="100" align="center">
									</el-table-column>
									<el-table-column prop="currentB" label="电流B(A)" width="100" align="center">
									</el-table-column>
									<el-table-column prop="currentC" label="电流C(A)" width="100" align="center">
									</el-table-column>
									<!-- <el-table-column
                    prop="activePowerTotal"
                    label="功率"
                    width="100"
                    align="center"
                  >
                  </el-table-column> -->
									<el-table-column prop="forwardActiveEnergyTotal" label="总电能(kW·h)" width="150"
										align="center">
									</el-table-column>
									<!-- <el-table-column
                    prop="powerFactorTotal"
                    label="功率因数"
                    width="100"
                    align="center"
                  >
                  </el-table-column> -->
									<el-table-column prop="frequency" label="频率(Hz)" align="center">
									</el-table-column>
									<el-table-column prop="activePowerA" label="A相有功功率" align="center" width="110">
									</el-table-column>
									<el-table-column prop="activePowerB" label="B相有功功率" align="center" width="110">
									</el-table-column>
									<el-table-column prop="activePowerC" label="C相有功功率" align="center" width="110">
									</el-table-column>
									<el-table-column prop="activePowerTotal" label="总有功功率" align="center" width="110">
									</el-table-column>
								</el-table>
								<div class="block">
									<el-pagination v-show="total > 0" @size-change="handleQueryElectric"
										@current-change="handleQueryElectric" :current-page.sync="queryParams.current"
										:page-sizes="[100, 200, 400, 600, 800, 1000]" :page-size.sync="queryParams.size"
										layout="total, sizes, prev, pager, next, jumper" :total="total">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="水表历史数据" name="water" v-if="$root.waterHistoryTabShow">
						<div>
							<el-form ref="form" :model="form" label-width="80px" size="small" style="margin-top: 15px">
								<el-form-item label="数据时间">
									<el-date-picker v-model="queryParamsWater.createStartTime" type="datetime"
										placeholder="选择开始日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
									<label> 到 </label>
									<el-date-picker v-model="queryParamsWater.createEndTime" type="datetime"
										placeholder="选择结束日期" class="searchTag" value-format="yyyy-MM-dd HH:mm:ss"
										:clearable="false">
									</el-date-picker>
								</el-form-item>
								<el-form-item label="水表厂商">
									<el-select v-model="queryParamsWater.producer" placeholder="请选择" clearable
										filterable>
										<el-option v-for="item in waterProducerOptions" :key="item.key"
											:label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="水表编号">
									<el-input v-model="queryParamsWater.meterAddr" class="searchTag" clearable
										@keyup.enter.native="handleQueryWater(true)">
									</el-input>
								</el-form-item>
								<br />
								<el-form-item label="商户编号">
									<el-input v-model="queryParamsWater.code" class="searchTag" clearable
										@keyup.enter.native="handleQueryWater(true)"></el-input>
								</el-form-item>
								<el-form-item label="商户名称">
									<el-select v-model="queryParamsWater.name" placeholder="" clearable filterable
										class="searchTag">
										<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
											:value="item.name">
										</el-option>
									</el-select>
								</el-form-item>
								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleQueryWater(true)">
									查询</el-button>
								<el-button type="primary" icon="iconfont icon-excel" size="small"
									style="background-color: #23c6c8 !important" @click="exportToExcelWater">导出
								</el-button>
							</el-form>
							<div class="tableStyle">
								<el-table :data="waterTableData" style="width: 100%" height="92%"
									id="waterDaraReportTable">
									<el-table-column type="index" width="65" label="序号" align="center"
										:index="indexMethodWater">
									</el-table-column>
									<el-table-column prop="meterAddr" label="水表编号" align="center">
									</el-table-column>
									<el-table-column prop="code" label="商户编号" align="center">
									</el-table-column>
									<el-table-column prop="name" label="商户名称" align="center">
									</el-table-column>
									<el-table-column prop="producer" label="水表厂商" align="center">
									</el-table-column>
									<el-table-column prop="dataTime" label="数据时间" align="center">
									</el-table-column>
									<el-table-column prop="batteryVoltage" label="电池电压" width="150" align="center">
									</el-table-column>
									<el-table-column prop="signalIntensity" label="信号强度" width="150" align="center">
									</el-table-column>
									<el-table-column prop="cumulativeFlow" label="累计流量(m³)" align="center">
									</el-table-column>
								</el-table>
								<div class="block">
									<el-pagination v-show="total1 > 0" @size-change="handleQueryWater"
										@current-change="handleQueryWater" :current-page.sync="queryParamsWater.current"
										:page-sizes="[100, 200, 400, 600, 800, 1000]"
										:page-size.sync="queryParamsWater.size"
										layout="total, sizes, prev, pager, next, jumper" :total="total1">
									</el-pagination>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		selectDictionaryListByName,
		selectMeterProducerList,
		selectWaterProducerList,
		selectLessee,
		selectMeter,
	} from '../../api/comboboxLoad';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import {
		electricDataComprehensiveQuery,
		waterDataComprehensiveQuery,
		selectListLesseeName,
	} from '../../api/report/dataReport';
	import {
		translateObjectEmptyAttributeToNull,
		getCurDayStartTime,
		getCurDayEndTime,
		getCurMonthFirstTime,
		getLastMounth
	} from '../../untils/func';
	import exportTable from '../../untils/exportTable';

	export default {
		data() {
			return {
				form: {},
				activeName: 'electric',
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
					createStartTime: getCurDayStartTime(),
					createEndTime: getCurDayEndTime(),
				},
				queryParamsWater: {
					current: 1,
					size: 100,
					createStartTime: getCurMonthFirstTime(),
					createEndTime: getLastMounth(),
				},
				loading: false,
				total: 0,
				total1: 0,
				meterTypeOptions: [], //电表制式
				meterProducerOptions: [], // 电表厂商类型options
				waterProducerOptions: [], //水表厂商类型options
				tableData: [],
				merchantNameOptions: [],
				electricTableData: [],
				waterTableData: [],

				lesseeNameOptions: [],
				lesseeNameQueryParams: {
					current: 1,
					size: 10000,
				},
				meterAddrOptions: [],
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			async init() {
				await this.handleQueryElectric();
				await this.handleQueryWater();
				await this.getMeterType();
				await this.getMeterProducer();
				await this.getWaterProducer();
				await this.getSelectLessee();
				await this.getLesseeNameOption();
				await this.getSelectMeter();
			},
			changeProducer(row) {
				console.log(row);
			},
			// 获取商户名称下拉框
			async getLesseeNameOption() {
				let param = this.lesseeNameQueryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectListLesseeName(param).then();
				this.lesseeNameOptions = response.data;
			},
			// 获取电表编号
			async getSelectMeter() {
				const res = await selectMeter().then();
				this.meterAddrOptions = res.data;
			},
			async handleQueryElectric(isSearchBtn) {
				if (isSearchBtn == true) {
					this.queryParams.current = 1;
				}
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await electricDataComprehensiveQuery(param).then();
				this.electricTableData = response.data;
				this.total = response.total;
				this.loading = false;
			},
			async handleQueryWater(isSearchBtn) {
				if (isSearchBtn == true) {
					this.queryParamsWater.current = 1;
				}
				this.loading = true;
				let param = this.queryParamsWater;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await waterDataComprehensiveQuery(param).then();
				this.waterTableData = response.data;
				this.total1 = response.total;
				this.loading = false;
			},
			async exportToExcelElectric() {
				if (this.electricTableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					if (this.total > 10000) {
						this.$message.error(
							'数据太多,不允许导出,请筛选导出(数据条数不能大于10000条)'
						);
					} else {
						let size = this.queryParams.size;
						this.queryParams.size = this.total;
						this.queryParams.current = 1;
						await this.handleQueryElectric();
						exportTable.exportExcel('electricDataReportTable', '电表历史数据');
						this.queryParams.size = size;
						await this.handleQueryElectric();
					}
				}
			},
			async exportToExcelWater() {
				if (this.waterTableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					if (this.total1 > 10000) {
						this.$message.error(
							'数据太多,不允许导出,请筛选导出(数据条数不能大于10000条)'
						);
					} else {
						let size = this.queryParamsWater.size;
						this.queryParamsWater.size = this.total1;
						this.queryParamsWater.current = 1;
						await this.handleQueryWater();
						exportTable.exportExcel('waterDaraReportTable', '水表历史数据');
						this.queryParamsWater.size = size;
						await this.handleQueryWater();
					}
				}
			},
			// 下拉列表数据
			async getMeterType() {
				// 电表制式
				const res = await selectDictionaryListByName(
					dictionaryConstant.METER_TYPE
				).then();
				this.meterTypeOptions = res.data;
			},
			async getMeterProducer() {
				// 电表厂商类型
				const res = await selectMeterProducerList().then();
				this.meterProducerOptions = res.data;
			},
			async getWaterProducer() {
				// 水表厂商类型
				const res = await selectWaterProducerList().then();
				this.waterProducerOptions = res.data;
			},
			// 获取商户名称下拉列表数据
			async getSelectLessee() {
				const res = await selectLessee().then();
				this.merchantNameOptions = res.data;
			},
			indexMethodElectric(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
			indexMethodWater(index) {
				let num =
					this.queryParamsWater.size * (this.queryParamsWater.current - 1) +
					index +
					1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
		margin-bottom: 10px;
	}

	.searchTag {
		width: 200px;
	}

	/deep/ .el-tabs {
		height: 100% !important;

		/deep/ .el-tabs__content {
			height: calc(100% - 39px) !important;
		}
	}

	.el-button {
		margin-left: 10px;
	}

	.tableStyle {
		height: calc(100vh - 368px);
	}

	@media screen and (max-width: 1400px) {
		.tableStyle {
			height: calc(100vh - 400px);
		}
	}

	.block {
		margin-top: 15px;
	}

	.el-card__body {
		height: 100% !important;
	}

	/deep/ .el-tabs__content {
		height: calc(100% - 39px) !important;
	}
</style>
